import { i18n } from "@/i18n";

export default {
  path: "/landing",
  name: "LandingLayoutView",
  component: () => import(/* webpackChunkName: "landing" */ "@/views/Landing/LandingLayoutView.vue"),
  meta: {
    authRequired: false,
    bareLayout: true,
    breadcrumb: false,
  },
  children: [
    {
      path: "",
      name: "matchingCandidacyLanding",
      component: () => import(/* webpackChunkName: "landing" */ "@/views/Landing/CandidacyLandingFormView.vue"),
      meta: {
        title: i18n.global.t("landing.hero.tag"),
        heroTagKey: "landing.hero.tag",
        // CandidacyLandingFormView obtient déjà l'image du hero dans son propre appel bootstrap
        // (habillage.headerImage) - un second fetch ici via LandingLayoutView ferait doublon et
        // grèverait le quota de captcha du bootstrap pour rien.
        skipHeroImageFetch: true,
      },
    },
    {
      path: "groups",
      name: "matchingCandidacyGroups",
      component: () => import(/* webpackChunkName: "landing" */ "@/views/Landing/CandidacyGroupsView.vue"),
      meta: {
        title: i18n.global.t("candidacyGroups.hero.title"),
        heroTagKey: "candidacyGroups.hero.tag",
        heroTitleKey: "candidacyGroups.hero.title",
      },
    },
    {
      path: "donnees-securisees",
      name: "matchingSecureData",
      component: () => import(/* webpackChunkName: "landing" */ "@/views/Landing/SecureDataView.vue"),
      meta: {
        title: i18n.global.t("secureData.hero.title"),
        heroTagKey: "secureData.hero.tag",
        heroTitleKey: "secureData.hero.title",
      },
    },
    {
      path: "desabonnement",
      name: "matchingUnsubscribe",
      component: () => import(/* webpackChunkName: "landing" */ "@/views/Landing/UnsubscribeView.vue"),
      meta: {
        title: i18n.global.t("unsubscribe.hero.title"),
        heroTagKey: "unsubscribe.hero.tag",
        heroTitleKey: "unsubscribe.hero.title",
      },
    },
  ],
};
